import React from "react";
import "./HrdBlore.css";
const HrdBlore = () => {
  return (
    <div className="hrdBloreContainer">
      <h1>
        HRD <span>Attestation</span> in Bangalore
      </h1>
      <p>
        HRD (Human Resource Department) attestation is a procedure which is done
        by the HRD of the State. It is the 1st step of educational document
        legalization in India. It is the procedure which is done by the
        authorities of the HRD Ministry on the state level to verify educational
        documents such as degree certificate. It is the legalization process
        done to prove the authenticity of the document.
      </p>
      <p>
        After the completion of document attestation, the stamp on a certificate
        is exhibiting the authenticity of documents which is also known as an
        HRD certificate. Goodwayattestation is a leading agency that provides
        the affordable services of HRD attestation in Bangalore by reaching the
        authorities & assisting you in getting your document attested quickly &
        hassle-free. Goodwayattestation is approved by Ministries & embassies in
        India as well as abroad.
      </p>
    </div>
  );
};

export default HrdBlore;
